import { useResponsive } from '@/hooks/useResponsive'
import { MonthGraph } from '@/pages/golf/detailSearch/_components/graphs/monthGraph'
import { PeriodGraph } from '@/pages/golf/detailSearch/_components/graphs/periodGraph'
import { RegionGraph } from '@/pages/golf/detailSearch/_components/graphs/regionGraph'
import { WeekGraph } from '@/pages/golf/detailSearch/_components/graphs/weekGraph'
import { RootState } from '@/redux/store'
import { useSelector } from 'react-redux'
import styled from 'styled-components'

export const DetailSearchGraph = () => {
  const {
    monthData,
    monthAvgPriceByRegion,
    quarterData,
    yearData,
    weekData,
    weekAvgPriceByRegion,
  } = useSelector((state: RootState) => state.golfSearch.graphData)

  const { areaCd, holeType } = useSelector(
    (state: RootState) => state.golfSearch.searchParams,
  )

  const { regionAvgPrice } = useSelector(
    (state: RootState) => state.golfSearch.graphData,
  )

  const safeGraphData = monthData && monthData.length ? monthData : []
  const isMonthDataEmpty = safeGraphData.every((arr) =>
    arr.every((item) => item === 0),
  )

  const safeWeekData = weekData && weekData.length ? weekData : [[], [], [], []]
  const { isMobile, isTablet, isDesktop } = useResponsive()
  const safeWeekAvgPriceByRegion =
    weekAvgPriceByRegion && weekAvgPriceByRegion.length
      ? weekAvgPriceByRegion
      : []

  const isWeekDataEmpty = safeWeekData.every((arr) =>
    arr.every((item) => item === 0),
  )

  return (
    <GraphWrapper>
      {/*!isMonthDataEmpty && (
        <MonthGraph
          monthData={monthData}
          monthAvgPriceByRegion={monthAvgPriceByRegion}
          areaCd={areaCd}
          isDualGraph={true}
        />
      )*/}
      <div
        style={{
          padding: isMobile ? '10px 15px' : '0',
          wordBreak: 'keep-all',
          lineHeight: '1.4',
          fontSize: isMobile ? '13px' : '14px',
          whiteSpace: 'normal',
          overflow: 'visible',
        }}
      >
        <div>
          {!areaCd
            ? `* 지역을 선택하면 전국과 지역별 평균 비교 그래프로 바뀌어요.`
            : `* 지도에서 골프장을 선택하면 전국, 지역, 골프장별 평균 비교 그래프로 바뀌어요.`}
        </div>
        <div>
          {isMobile && `* 그래프를 옆으로 밀면 더 많은 내용을 볼 수 있어요.`}
        </div>
      </div>
      {!isWeekDataEmpty && (
        <div style={{ padding: isMobile ? '0 15px' : '0' }}>
          <WeekGraph
            weekData={weekData}
            weekAvgPriceByRegion={weekAvgPriceByRegion}
            areaCd={areaCd}
            isWeekDualGraph={true}
            holeType={holeType}
          />
        </div>
      )}
      {/*<PeriodGraph data={quarterData} type="quarter" />*/}
      {/*<PeriodGraph data={yearData} type="year" />*/}
      {/*<RegionGraph regionAvgPrice={regionAvgPrice} />*/}
    </GraphWrapper>
  )
}

const GraphWrapper = styled.div`
  width: 100%;
  margin-top: 20px;
`
